import React, { useEffect, useRef } from 'react'
import { Option, OptionsList } from '../../CreateParam/ManageStructures/OptionsDropdown/style'
import editIcon from '../../../../../assets/global-assets/edit.svg'

interface PropsType {
  onClose: () => void
  onEdit: () => void
}

const CertificateStructureOptions: React.FC<PropsType> = ({ onClose, onEdit }) => {
  const dropdownRef = useRef<HTMLUListElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onClose])

  return (
    <OptionsList ref={dropdownRef} style={{ top: '1.75rem', right: 0 }}>
      <Option
        onClick={() => {
          onEdit()
          onClose()
        }}
      >
        <img src={editIcon} alt="edit-icon" /> Editar
      </Option>
    </OptionsList>
  )
}

export default CertificateStructureOptions
